export default __webpack_public_path__ + "static/multiscraps-414a1dbad78c88b1dee3222dde236af7.png";